import styled from 'styled-components';

export const Placeholder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  aspect-ratio: ${(props) => props.$ratio};
  padding: 16px;
  box-sizing: border-box;
  border: 2px dashed #7197d6;
  border-radius: 10px;
  background: rgba(113, 151, 214, 0.1);
  color: #0f2137;
  text-align: center;

  strong {
    font-size: 12px;
    letter-spacing: 0.16em;
    color: #46679f;
  }

  span {
    font-size: 15px;
    line-height: 1.5;
  }

  code {
    max-width: 100%;
    overflow-wrap: anywhere;
    font-size: 12px;
    background: rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    padding: 2px 6px;
  }
`;
